import { KeyRound } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer id="contacto" className="border-t border-white/10 mt-24 bg-[#0A0A0A]" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 grid md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <div className="flex items-center gap-2.5 mb-4">
          <div className="w-9 h-9 rounded-md bg-[#FFC107] flex items-center justify-center">
            <KeyRound className="w-5 h-5 text-black" strokeWidth={2.5} />
          </div>
          <span className="font-display font-bold text-xl text-white">SasCerrajería</span>
        </div>
        <p className="text-sm text-[#A1A1AA] max-w-sm leading-relaxed">
          Cerrajería de automoción 24/7. Apertura de vehículos, duplicado de llaves con chip y programación de mandos a domicilio.
        </p>
      </div>
      <div>
        <h4 className="font-display font-semibold mb-4 text-white text-sm uppercase tracking-wider">Servicio</h4>
        <ul className="space-y-2 text-sm text-[#A1A1AA]">
          <li><Link to="/reservar" className="hover:text-[#FFC107]">Reservar</Link></li>
          <li><a href="/#servicios" className="hover:text-[#FFC107]">Servicios</a></li>
          <li><Link to="/admin/login" className="hover:text-[#FFC107]" data-testid="footer-admin-link">Acceso taller</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-display font-semibold mb-4 text-white text-sm uppercase tracking-wider">Contacto</h4>
        <ul className="space-y-2 text-sm text-[#A1A1AA]">
          <li>
            <a href="https://wa.me/34641719027" target="_blank" rel="noopener noreferrer" className="hover:text-[#25D366] transition-colors" data-testid="footer-whatsapp">
              WhatsApp · 641 719 027
            </a>
          </li>
          <li><a href="tel:+34641719027" className="hover:text-[#FFC107] transition-colors">Llamada · +34 641 719 027</a></li>
          <li>info@sascerrajeria.com</li>
          <li>Tàrrega (Lleida) · 24h · 365 días</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-5 flex flex-col md:flex-row justify-between gap-3 text-xs text-[#71717A]">
        <span>© 2026 SasCerrajería · Todos los derechos reservados</span>
        <span className="font-mono">v1.0 · Emergencia 24/7</span>
      </div>
    </div>
  </footer>
);
